import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"
import Icon from "./Icon"

export default function SortDropdown({toggledFacet, setToggledFacet}) {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);
    const [optionName, setOptionName] = useState("");

    // keydown 'esc' will close dropdown
    
    // useEffect(() => {
    //     const handleKeydown = (event) => {
    //         if(event.key === 'Escape' || event.keyCode === 27) {
    //             toggleSort();
    //         }
    //     }
    //     if(sortOpen) {
    //         window.document.addEventListener('keydown', handleKeydown)
    //         return () => window.document.removeEventListener('keydown', handleKeydown)
    //     }
    // }, [ sortOpen ])

    // click outside will close dropdown

    // useEffect(() => {
    //     const handleClick = (event) => {
    //         if(
    //             !dropdownRef.current.contains(event.target) && 
    //             !toggleRef.current.contains(event.target)
    //         ) {
    //             toggleSort();
    //         };
    //     };

    //     if(sortOpen && dropdownRef?.current && toggleRef?.current) {
    //         window.document.addEventListener('click', handleClick);
    //         return () => window.document.removeEventListener('click', handleClick);
    //     };
    // }, [sortOpen, dropdownRef, toggleRef]);

    const handleSortChange = (event) => {
        // console.log(event.target)
        const inputField = event.target;
        const nextSibling = inputField.nextSibling;
        setSort(event.target.value);
        setOptionName(nextSibling.textContent);
        // toggleSort();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    useEffect(()=>{
        if(toggledFacet === "ns-sort-tab"){
            if(!sortOpen){
                setSortOpen(true);
            }
        } else {
            if(sortOpen){
                setSortOpen(false);
            }
        }

        const inputFields = document.querySelectorAll(`input[name="ns-sort"]`);
        if(inputFields){
            const inputField = Array.from(inputFields).find(input => input.value === activeSort);
            // if(!inputField) return;
            if(inputField){
                const nextSibling = inputField.nextSibling;
                setOptionName(nextSibling.textContent);
            }
        }
    }, [toggledFacet, setToggledFacet])

    // console.log(activeSort, "activeSort");
    // console.log(optionName, "optionName");
    // console.log(sortOpen, "sortOpen");

    return (
        <div class="ns-dropdown-container accordian collection-filters__sort-by">
            <div class="justify-between">
                <button
                // button button--collapsible
                    className="ns-custom-sort-toggle-btn"
                    type="button"
                    aria-haspopup="true"
                    aria-controls="ns-sort-dropdown"
                    aria-labelledby="sort-label"
                    aria-expanded={sortOpen}
                    tabIndex="0"
                    onClick={toggleSort}
                    ref={toggleRef}
                >
                    {/* <span
                        className="body-2 pr-[5px] pl-[16px] cursor-pointer lg:pl-[30px]"
                        id="sort-label"
                    >
                        Sort By:
                    </span> */}
                    <div class={`flex items-center grow accordion__title ${sortOpen && 'ns-pb-20'}`}>  
                        SORT BY
                    </div>
                    {/* <span className="body-2--medium hidden lg:inline">
                        {sortOptions.find(option => option.id === activeSort).value.name}
                    </span> */}
                    <Icon name="arrow" className={"ns-arrow-sort-dropdown"}/>
                </button>
            </div>
            <div class="w-full max-h-[300px] transition-[max-height] duration-300 ease-in overflow-hidden group-open:ease-out group-open:max-h-0">
                <span class={`pt-[2px] paragraph-4 ${activeSort && !sortOpen && optionName ? "" : "hidden" }`}>
                    {activeSort && !sortOpen && optionName ? (
                        <span class="pr-1.5" style="color:#404040;">{optionName}</span>
                    ) : ("")}
                </span>
            </div>
            
            <div
                // className="absolute bg-white m-w-full z-1"
                id="ns-sort-dropdown"
                aria-hidden={!sortOpen}
                ref={dropdownRef}
                tabIndex="0"
                class="content accordion__content"
                >
                    {/* bg-background-0 z-30 absolute mt-[20px] w-[200px] h-fit flex flex-col lg:w-[290px] lg:h-auto lg:pr-[0px] lg:right-0 lg:right-auto lg:mt-[2px] lg:top-[30px] lg:pt-[0px] */}
                <ul className="ns-sort-menu filter-group-display__list flex flex-col gap-y-15">
                    {sortOptions.map((option) => (
                        <li 
                            key={option?.id}
                            // pb-[20px] pl-[20px] pr-[20px] lg:pb-[16px] lg:border-b-0
                            class="ns-sort-option filter-group-display__list-item"
                        >
                            <label
                                // className="wrap flex flex-row items-center cursor-pointer"
                                class="radio"
                                tabIndex="0"
                            >
                                <input
                                // visually-hidden sr-only
                                    className="sm"
                                    type="radio"
                                    name="ns-sort"
                                    value={option?.id} 
                                    checked={(activeSort === option?.id)}
                                    onChange={handleSortChange}
                                />
                                {/* className={`hover:underline ${activeSort === option.id ? "underline body-2--medium" : ""}`} */}
                                <span>
                                    {option.value.name}
                                </span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}